export const demoRandomArray = [
  1.2,
  0.9,
  0.88,
  0.85,
  0.98,
  1.1,
  1.15,
  1.2,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88,
  0.85,
  0.98,
  1.10,
  1.15,
  1.20,
  1.25,
  1.20,
  0.9,
  0.88
]



// WEBPACK FOOTER //
// ./src/data/demo.js